import { isEmpty } from "lodash";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { isSecurityRatingAvailable, isSecurityRatingInProgress, SecurityRatingConfigStatus, SecurityRatingContext } from "services/common/SecurityRatingUtils";
import { getThirdpartySecurityRatingConfig } from "services/edge/SecurityRatingService";
import { Context } from "states/Store";
import SecurityRatingInProgress from "./SecurityRatingInProgress";
import SecurityRatingActivationForm from "./security-rating-form/SecurityRatingActivationForm";
import SecurityRatingScores from "./security-rating-scores/SecurityRatingScores";
import { ERROR } from "services/common/Constants";
import SecurityRatingError from "./SecurityRatingError";

const SecurityRatingPanel = ({ data, thirdPartyId, onRiskChange = () => { } }) => {
  const [state, dispatch] = useContext(Context);

  const [isLoading, setLoading] = useState(true);

  const [config, setConfig] = useState();
  const [displayError, setDisplayError] = useState(false);

  const fetchSecurityRatingConfig = useCallback(async () => {
    try {
      setLoading(true);
      const conf = await getThirdpartySecurityRatingConfig(
        state.account.id,
        thirdPartyId
      );
      setConfig(conf.content)
      setDisplayError(!isEmpty(conf.content?.company?.error))
    } catch (error) {
      if (error?.message?.status === 404) {
        setConfig({})
      } else {
        dispatch({
          type: "ALERT",
          alert: { type: ERROR, msg: error?.message?.messages?.error?.[0]?.code || "INTERNAL_ERROR" },
        });
      }
    }
    setLoading(false);
  }, [state.account.id, thirdPartyId, dispatch])

  useEffect(() => {
    if (state.account.id && thirdPartyId) {
      fetchSecurityRatingConfig();
    }
  }, [state.account.id, thirdPartyId, fetchSecurityRatingConfig]);

  const isActiveButHasErrors = (config) => {
    return config.status === SecurityRatingConfigStatus.ACTIVE && config?.company?.error != null;
  }


  const securityRatingContext = useMemo(
    () => ({
      config: config,
      setConfig: setConfig,
      onRiskChange: onRiskChange
    }),
    [config, setConfig, onRiskChange]
  );

  const render = () => {
    if (isLoading) return "";

    if (displayError) {
      return <SecurityRatingError error={config?.company?.error} goBack={() => setDisplayError(false)} />
    }

    if (isEmpty(config) ||
      config.status === SecurityRatingConfigStatus.DRAFT || 
      config.status === SecurityRatingConfigStatus.INACTIVE || 
      isActiveButHasErrors(config)
    ) {
      return <SecurityRatingActivationForm thirdPartyId={thirdPartyId}/>;
    } else {
      if (isSecurityRatingInProgress(data)) return <SecurityRatingInProgress />
      if (isSecurityRatingAvailable(data)) return <SecurityRatingScores data={data} onRiskChange={onRiskChange} thirdPartyId={thirdPartyId}/>;
    }
  }

  return (
    <SecurityRatingContext.Provider value={securityRatingContext}>
      {render()}
    </SecurityRatingContext.Provider>
  )
}

export default SecurityRatingPanel;